// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

import jquery from "jquery"
window.$ = window.jQuery = jquery
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap
import "../stylesheets/application"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

let movieKeywordDelegationInitialized = false

function setupMovieKeywordTagClickDelegation() {
  if (movieKeywordDelegationInitialized) return
  movieKeywordDelegationInitialized = true

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return

    const tag = event.target.closest('.keyword-tag')
    if (!tag) return

    const keywordInput = document.getElementById('movie_keyword_input')
    if (!keywordInput) return

    const keyword = tag.getAttribute('data-keyword')
    const currentValue = keywordInput.value.trim()
    const keywords = currentValue.split(/[,、\s　]+/).filter((k) => k.length > 0)

    if (keywords.includes(keyword)) return

    keywordInput.value = currentValue === '' ? keyword : `${currentValue}, ${keyword}`

    tag.classList.add('btn-success')
    tag.classList.remove('btn-outline-secondary')
    setTimeout(() => {
      tag.classList.remove('btn-success')
      tag.classList.add('btn-outline-secondary')
    }, 500)
  })
}

setupMovieKeywordTagClickDelegation()

document.addEventListener('turbolinks:load', ()=> {
  // キーワード追加の動作はツールチップ初期化とは独立させる
  setupMovieKeywordTagClickDelegation()

  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })
});
